export default "__VITE_ASSET__eVF1T1Il__"